import { render } from "./ForgotPassword.vue?vue&type=template&id=2d73eca8"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "2d73eca8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d73eca8', script)) {
    api.reload('2d73eca8', script)
  }
  
  module.hot.accept("./ForgotPassword.vue?vue&type=template&id=2d73eca8", () => {
    api.rerender('2d73eca8', render)
  })

}

script.__file = "resources/js/Pages/Auth/ForgotPassword.vue"

export default script